// src/utils/mentionUtils.js
// 80차 계속: 크루 메시지 "@닉네임"/"@전체" 텍스트 파싱 — Firebase/RN 의존성이 전혀
// 없는 순수 함수라, dateUtils.js와 동일한 이유(crewService.js는 Firebase 클라이언트
// 초기화를 거쳐서 jest testEnvironment:'node'로는 테스트 불가)로 별도 파일로 분리해
// __tests__/services/mentionUtils.test.js에서 모킹 없이 바로 테스트할 수 있게 함.

// members: getCrewMemberProfilesCF가 반환하는 {uid, nickname, ...}[] 그대로 사용.
// 닉네임에 공백이 없다는 전제(가입 시 공백 미허용 관행)로 앞뒤 공백/문장 경계 기준 매칭.
export const parseMentions = (text, members = []) => {
  const mentionAll = /(^|\s)@전체(?=\s|$)/.test(text || '');
  const mentions = [];
  for (const m of members) {
    if (!m.nickname) continue;
    const escaped = m.nickname.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    if (new RegExp(`(^|\\s)@${escaped}(?=\\s|$)`).test(text || '')) mentions.push(m.uid);
  }
  return { mentions: [...new Set(mentions)], mentionAll };
};
